<template>
  <v-dialog
    v-model="dialog"
    width="800"
    :fullscreen="$vuetify.breakpoint.mobile"
    scrollable
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn depressed small color="primary" @click.stop="dialog = !dialog">
        Editar
      </v-btn>
    </template>
    <v-card color="background">
      <v-card-title>
        Editar búsqueda
        <v-spacer></v-spacer>

        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pb-0 px-0">
        <search ref="search" @save="save"></search>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { EditSearch } from "@/graphql/mutations/searches";
import Search from "@/components/shared/Search";

export default {
  data: () => ({
    dialog: false
  }),

  props: {
    search: {
      type: Object,
      required: true
    }
  },

  watch: {
    dialog(val) {
      if (val) {
        this.$nextTick(() => {
          var search = Object.assign({}, this.search);
          delete search.id;
          delete search.resultsCount;
          delete search.unseenResults;
          delete search.__typename;

          this.$refs.search.search = search;
        });
      }
    }
  },

  methods: {
    save(search) {
      this.$apollo
        .mutate({
          mutation: EditSearch,
          variables: {
            input: {
              attributes: search,
              id: this.search.id
            }
          }
        })
        .then(res => {
          this.$emit("reload");
          this.dialog = false;
        });
    }
  },

  components: { Search }
};
</script>
